const HEALTH_KEYS = {
  ERROR: 'error',
};

export { HEALTH_KEYS };
